import {remCalc} from '_themeUtils'

const price = {
    Price: {
        baseStyle: () => ({
            wrapper: {
                flexWrap: 'wrap',
                columnGap: {base: 'spacing.1', lg: 'spacing.4'},
                rowGap: 'spacing.none',
            },
            price: {
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(0.8),
            },
            discountedPrice: {
                textDecoration: 'line-through',
                color: 'color.text.grey.600',
            },
        }),
    },
}

export default price
